import { Type } from '@sinclair/typebox';
import { ProductItemSchema, UseFiltersSchema } from "./shared.mjs";
export const GetItemWithProductionSettingsQuerySchema = Type.Object({
    attributes: Type.String(),
    useFilters: UseFiltersSchema,
});
export const GetItemWithProductionSettingsResponseSchema = Type.Object({
    item: ProductItemSchema,
});
export const GetItemWithoutProductionSettingsQuerySchema = Type.Object({
    attributes: Type.String(),
    useFilters: UseFiltersSchema,
});
export const GetItemWithoutProductionSettingsResponseSchema = Type.Object({
    item: ProductItemSchema,
});
//# sourceMappingURL=production.js.map